import React from 'react';

interface SidebarProps {
  projectId: string;
  activeModule: 'project' | 'build' | 'test' | 'deploy' | 'usage' | 'logs';
}

const Sidebar: React.FC<SidebarProps> = ({ projectId, activeModule }) => {
  const modules = [
    { id: 'project', name: 'Project', icon: '📋', path: `/project/${projectId}` },
    { id: 'build', name: 'Build', icon: '🔨', path: `/project/${projectId}/build` },
    { id: 'test', name: 'Test', icon: '🧪', path: `/project/${projectId}/test` },
    { id: 'deploy', name: 'Deploy', icon: '🚀', path: `/project/${projectId}/deploy` },
    { id: 'usage', name: 'Usage', icon: '📊', path: `/project/${projectId}/usage` },
    { id: 'logs', name: 'Logs', icon: '📝', path: `/project/${projectId}/logs` }
  ];

  return (
    <div className="sidebar">
      <div className="project-header">
        <div className="logo" onClick={() => window.location.href = '/'}>
          LLM Playground
        </div>
      </div>
      <nav className="module-nav">
        {modules.map(module => (
          <button
            key={module.id}
            className={`nav-item ${activeModule === module.id ? 'active' : ''}`}
            onClick={() => window.location.href = module.path}
          >
            <span className="nav-icon">{module.icon}</span>
            <span className="nav-name">{module.name}</span>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;